import Tile4Wrapper from './Tile4Wrapper';

export default Tile4Wrapper;
